import React from 'react';
import { WithMarginComponent } from 'components/layout/style';
import { Children } from 'utils/types/react';
export * from './style';

interface WithMarginProps {
  children?: Children;
  margin?: string;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  height?: string;
}

export function WithMargin(props: WithMarginProps) {
  return <WithMarginComponent {...props} />;
}

WithMargin.defaultProps = {
  margin: '0',
};
